import React, {Component} from 'react';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle, NavItem} from 'reactstrap';
import PropTypes from 'prop-types';
import {Link, withRouter} from 'react-router-dom';

import conf from '../../../../shared/conf.js';
import {generate} from '../../../routes.js';
import connectModal from '../../../../shared/components/Modals/connect.js';
import UserAddModal from '../../../components/Modals/UserAddModal/UserAddModal.jsx';
import UserIcon from "../Icons/LoggedContent/UserIcon.jsx";
import {isUserFreelance} from "../../../../shared/services/userService.js";

class LoggedContent extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    className: PropTypes.string,
    search: PropTypes.bool
  };

  static defaultProps = {
    className: '',
    search: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      dropdownOpened: false,
      dropdownAccountOpened: false,
    };
  }

  toggleAccountShow = () => {
    this.setState({
      dropdownAccountOpened: !this.state.dropdownAccountOpened
    });
  };

  toggleShow = () => {
    this.setState({
      dropdownOpened: !this.state.dropdownOpened
    });
  };


  getCreateAccountLink() {
    return  (conf.accountTypes.freelance === this.props.currentUser.account_type)
      ? generate({name: 'create-freelance'})
      : '';
  }

  getFreelanceItems = () => {
    const isComplete = this.props.currentUser.complete

    if(!isComplete) {
      return [
        {
          type: 'link',
          text: 'Mon profil',
          route: generate({name: 'my-freelance-profile'})
        },
        {
          type: 'divider',
        },
        {
          type: 'a',
          text: 'Se déconnecter',
          route: `${process.env.API_URL}/logout`
        },
      ]
    }

    return [
      {
        type: 'link',
        text: 'Mon compte',
        route: generate({name: 'my-account'})
      },
      {
        type: 'link',
        text: 'Modifier mes alertes',
        route: generate({name: 'edit-freelance.alertes'})
      },
      {
        type: 'divider',
      },
      {
        type: 'a',
        text: 'Se déconnecter',
        route: `${process.env.API_URL}/logout`
      },
    ]
  }

  getItems = () => {
    return [
      {
        type: 'link',
        text: 'Mon compte',
        route: generate({name: 'edit-do.account'}),
      },
      {
        type: 'divider',
      },
      {
        type: 'a',
        text: 'Se déconnecter',
        route: `${process.env.API_URL}/logout`
      },
    ]
  }

  addUser = () => {
    this.props.openUserAddModal({});
  }

  render() {
    const {currentUser} = this.props;

    const items = (isUserFreelance(currentUser))
      ? this.getFreelanceItems()
      : this.getItems()

    return (
      <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-center">
        {/*Mobile*/}
        {items.map((navItem, index) => {
          const key= `mobile-nav-item-${index}`

          if(navItem.type === 'link') {
            return (
              <NavItem className="d-block d-lg-none" key={key}>
                <Link className="nav-link px-0" to={navItem.route}>{navItem.text}</Link>
              </NavItem>
            )
          }

          if(navItem.type === 'a') {
            return (
              <NavItem className="d-block d-lg-none" key={key}>
                <a className="nav-link px-0" href={navItem.route}>
                  {navItem.text}
                </a>
              </NavItem>
            )
          }

          return null
        })}

        {/*Desktop*/}
        <Dropdown className="my-auto my-auto d-block" isOpen={this.state.dropdownAccountOpened} toggle={this.toggleAccountShow}>
          <DropdownToggle caret={false} color="link" style={{height: '42px'}} className="d-none d-lg-block">
            <UserIcon />
          </DropdownToggle>
          <DropdownMenu right={true}>
            {items.map((navItem, index) => {

              const key= `desktop-nav-item-${index}`

              if(navItem.type === 'link') {
                return (<Link key={key} className="dropdown-item" to={navItem.route}>{navItem.text}</Link>)
              }

              if(navItem.type === 'a') {
                return (
                  <a  key={key} className="dropdown-item" href={navItem.route}>
                    {navItem.text}
                  </a>
                )
              }
              if(navItem.type === 'divider') {
                return (<DropdownItem  key={key} divider/>)
              }

              return null
            })}
          </DropdownMenu>
        </Dropdown>
      </div>
    )
  }
}

export default withRouter(connectModal({UserAddModal}, LoggedContent));
